import { FormField, FormBaseStore } from 'sos-common/js/commonTypes';
import { Dispatch } from 'redux';
import { thunkGetStateFunc } from 'sos-eservice-common/js/Redux';
import { SET_FORM_VALUE, SET_TOUCHED_MAP, setFormValueAction, setTouchedMapAction, setValidationResults } from 'sos-eservice-common/js/Redux/Actions';
import { doValidateByState } from 'sos-eservice-common/js/services';

export function setClarificationRegistersValue(
  internalRegisters: FormField<any>,
  registerPeriodClarifications: FormField<any>,
  touchedMap: Map<any, any>
) {
  return function (dispatch: Dispatch, getState: thunkGetStateFunc<FormBaseStore<any>>) {
    dispatch({
      type: SET_FORM_VALUE,
      payload: [registerPeriodClarifications, internalRegisters]
    } as setFormValueAction);

    dispatch({
      type: SET_TOUCHED_MAP,
      payload: touchedMap
    } as setTouchedMapAction);


    doValidateByState(getState()).then(validationResults => {
      dispatch(setValidationResults(validationResults));
    });
  };
}
